import { Fragments } from '@shared/api';
import { getSharedApolloClient } from '@shared/api/client';
import { getStore } from '@shared/store';
import { API } from '@shared/types/api';
import * as uuid from '@shared/util/uuid';

/*
    Create a message from a message draft
*/
export function messageFromDraft(draft: MBChatMessageDraft): API.ChatMessageFragment {
  const apolloClient = getSharedApolloClient();
  const store = getStore();
  // 1. get current user from the cache to create a proper optimistic message
  // TODO(fant): the default value below is a hack... Just after the user has
  // signed up, this fragment returns null. This causes UI to break later
  // since it expects message.sender to be set.
  const me =
    apolloClient.readFragment<API.ShortUserFragment>({
      id: `User${store.getState().appState.currentUserId}`,
      fragment: Fragments.user.short,
    }) || ({ id: store.getState().appState.currentUserId, fullName: '' } as any);

  // 2. create the message from the draft data
  return {
    id: Date.now(),
    sender: me,
    type: 'TEXT',
    subType: null,
    content: draft.content.trim(),
    createdAt: new Date().toISOString(),
    editedAt: null,
    urgent: draft.urgent,
    sentBySMS: false,
    meta: {
      id: Date.now(),
      uuid: uuid.v4(),
      channelName: 'TODO(fant)',
      tokens: [],
      reactions: [],
      attachments: draft.attachments.map(attachment => ({
        fileKey: attachment.fileKey,
        name: attachment.name,
        width: attachment.width,
        height: attachment.height,
        url: attachment.url,
        // TODO(fant): get this from the attachment instead...
        contentType: attachment.contentType,
        thumbnails: attachment.thumbnails,
      })),
      users: null,
      cardId: null,
      startDate: null,
      endDate: null,
    },
  };
}
